import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}age-group-product`;

export const getAgeGroupProducts = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },  
        credentials: 'include',
    });
}

export const getAgeGroupProductById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
        credentials: 'include',
    });
}

export const createAgeGroupProduct = (ageGroupProduct) => {
    const token = localStorage.getItem('token');

    return axios.post(`${API_URL_WEB}`,
        ageGroupProduct,
        {
            headers: {
                Authorization: `Bearer ${token}`, // Send token in Authorization header
            },
            credentials: 'include',
        });
}

export const updateAgeGroupProduct = (id, ageGroupProduct) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/${id}`,
        ageGroupProduct,
        {
            headers: {
                Authorization: `Bearer ${token}`, // Send token in Authorization header
            },
              credentials: 'include',
        });
}

export const deleteAgeGroupProduct = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateActive = (id, bannerProduct) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/active-age-group/${id}`,
        bannerProduct, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
          credentials: 'include',
    });
}
